import React from 'react';
import {Image, Line, Typography} from '@fupa/fupa-uikit';
import {convertToRoman} from 'app/helpers/convertToRoman';
import {Content, Container, Stat, TeamImage, Team} from 'app/components/standings/StandingsStyles';
import {LinkOnComponent} from 'app/components/links/link';
import styled from 'styled-components';

const AlltimeContainer = styled(Container)`
  &&& {
    background-color: transparent;
  }
`;

const AlltimeRow = ({team}) => {
  const TeamName =
    team.team.level > 1 ? team.team.name.middle + ' ' + convertToRoman(team.team.level) : team.team.name.middle;

  return (
    <Content>
      <LinkOnComponent enablehover={true.toString()} to={`/team/${team.team.slug}`}>
        <AlltimeContainer height={42}>
          <Stat align='left' setMaxWidth minWidth={24}>
            <Typography variant='body1'>{team.rank}.</Typography>
          </Stat>
          <TeamImage>
            <Image entity='emblem' src={team.team.image} width={32} height={32} fit={true} />
          </TeamImage>
          <Team>
            <Typography variant='body1'>{TeamName}</Typography>
          </Team>
          <Stat align='center' minWidth={32}>
            <Typography variant='body1'>{team.seasons}</Typography>
          </Stat>
          <Stat align='center' minWidth={36}>
            <Typography variant='body1'>{team.matches}</Typography>
          </Stat>
          <Stat align='center' minWidth={36} conditional>
            <Typography variant='body1'>{team.wins}</Typography>
          </Stat>
          <Stat align='center' minWidth={36} conditional>
            <Typography variant='body1'>{team.draws}</Typography>
          </Stat>
          <Stat align='center' minWidth={36} conditional>
            <Typography variant='body1'>{team.defeats}</Typography>
          </Stat>
          <Stat align='center' minWidth={36} conditional>
            <Typography variant='body1'>{team.goalDifference}</Typography>
          </Stat>
          <Stat align='center' minWidth={72} conditional>
            <Typography variant='body1'>
              {team.ownGoals}:{team.againstGoals}
            </Typography>
          </Stat>
          <Stat align='center' minWidth={36}>
            <Typography variant='body1'>{team.points}</Typography>
          </Stat>
        </AlltimeContainer>
      </LinkOnComponent>
      <Line />
    </Content>
  );
};

export default AlltimeRow;
